import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { BookOpen, ArrowLeft } from 'lucide-react';
import ShareBar from '../components/ShareBar';
import { useContent } from '../context/ContentContext';
import FlipbookModal from '../components/FlipbookModal';
import { issueSlug, shareUrl } from '../lib/issueSlug';

export default function IssuePage() {
  const { slug } = useParams();
  const { editions, loading } = useContent();
  const [open, setOpen] = useState(false);
  const issue = editions.find((e) => issueSlug(e) === slug);
  useEffect(() => { window.scrollTo(0, 0); }, [slug]);
  useEffect(() => { if (issue) document.title = `${issue.title} | ENERSIDER Energy Platform`; }, [issue]);

  if (!issue) {
    return (
      <div className="pt-40 pb-24 section-pad max-w-[1500px] mx-auto" data-testid="issue-not-found">
        <p className="text-[#666666]">{loading ? 'Loading issue…' : 'This issue could not be found.'}</p>
        <Link to="/magazine" className="inline-flex items-center gap-2 mt-6 text-[#D01919] font-medium"><ArrowLeft size={16} /> All issues</Link>
      </div>
    );
  }
  return (
    <div className="pt-32 md:pt-40 pb-24 section-pad" data-testid="issue-page">
      <div className="max-w-[1500px] mx-auto">
        <Link to="/magazine" className="inline-flex items-center gap-2 text-sm text-[#666666] hover:text-[#D01919] mb-10" data-testid="issue-back-link"><ArrowLeft size={16} /> All issues</Link>
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <button onClick={() => issue.pdfUrl && setOpen(true)} className="block w-full max-w-md mx-auto lg:mx-0" data-testid="issue-cover">
            <div className="rounded-2xl overflow-hidden shadow-2xl aspect-[3/4] ring-1 ring-black/5">
              {issue.cover ? <img src={issue.cover} alt={issue.title} className="w-full h-full object-cover" /> : <div className="w-full h-full bg-[#f4f4f4]" />}
            </div>
          </button>
          <div>
            <p className="eyebrow text-[#D01919] mb-4" data-testid="issue-month">ENERSIDER Magazine · {issue.month}</p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02]" data-testid="issue-title">{issue.title}</h1>
            {issue.summary ? <p className="text-[#666666] text-lg mt-5 leading-relaxed">{issue.summary}</p> : null}
            {issue.pdfUrl ? (
              <button onClick={() => setOpen(true)} data-testid="issue-read-button" className="inline-flex items-center gap-2 mt-8 bg-[#111111] text-white font-medium px-6 py-3.5 rounded-full hover:bg-[#D01919] transition-colors"><BookOpen size={18} /> Read the Issue</button>
            ) : null}
            <ShareBar url={shareUrl(issue)} text={`${issue.title} — ENERSIDER Magazine`} testid="issue-share" />
          </div>
        </div>
      </div>
      <FlipbookModal open={open} onClose={() => setOpen(false)} url={issue.pdfUrl} title={`${issue.title} · ${issue.month}`} />
    </div>
  );
}
